import { EmergencyHomeFilled } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import styles from "./ListItem.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ListItem = ({
  children,
  active,
  disabled,
  className,
  onClick,
  error,
  ...forwardProps
}) => {
  const classes = classnames(styles.listItem, {
    [styles.active]: active,
    [styles.disabled]: disabled,
    [styles.error]: error
  }, className);
  return /*#__PURE__*/_jsx("li", {
    ...forwardProps,
    className: classes,
    onClick: disabled ? undefined : onClick,
    children: /*#__PURE__*/_jsxs("button", {
      type: "button",
      className: styles.button,
      disabled: disabled,
      children: [error && /*#__PURE__*/_jsx(EmergencyHomeFilled, {
        size: "SMALL",
        className: styles.errorIcon
      }), children]
    })
  });
};